import * as React from 'react'
import { GroupedServices, ILeadOppProduct } from '@user/store/leadOppProducts'
import { IServiceFrequency } from '@user/store/serviceFrequency'
import Box from '@mui/material/Box'
import {
  useDragData,
  DraggableItemWrapper,
  DropResult,
} from '@user/utils/Draggable'
import { DraggableServiceCard } from './DraggableServiceCard'
import { useFormikContext } from 'formik'
import {
  CreateAgreementFormPacketModel,
  CreateAgreementTemplateDetails,
} from './typings'

type Props = {
  type: string
  services: ILeadOppProduct[]
  serviceFrequencies: IServiceFrequency[]
  group: GroupedServices
  groupIndex: number
}

export function DraggableAgreementServicesList(props: Props) {
  const { serviceFrequencies, services, type, group, groupIndex } = props

  const { setValues, values } =
    useFormikContext<CreateAgreementFormPacketModel>()
  const { templates } = values

  const onDragEnd = React.useCallback(
    (result: DropResult) => {
      if (result.id === 'templateServices') {
        const tempTemplates = [...templates]
        const tempServices = [...services]
        const dragged = tempServices.splice(result.sourceIndex, 1).pop()
        if (dragged) {
          tempServices.splice(result.destinationIndex, 0, dragged)

          const template = tempTemplates?.find(
            (row: CreateAgreementTemplateDetails) =>
              row?.templateId == Number(type),
          ) as CreateAgreementTemplateDetails
          if (template) {
            const templateIndex = templates?.findIndex(
              (row: CreateAgreementTemplateDetails) =>
                row?.templateId == Number(type),
            )
            const updatedGroup = { ...group, services: tempServices }
            template.groupedServices?.splice(groupIndex, 1, updatedGroup)
            const updatedTemplate = {
              ...template,
              services:
                template.groupedServices?.flatMap((group) => group.services) ??
                [],
            }
            tempTemplates.splice(templateIndex, 1, updatedTemplate)

            setValues((v) => {
              return { ...v, templates: tempTemplates }
            })
          }
        }
      }
    },
    [setValues, type, group, groupIndex, services, templates],
  )

  const { containerRef, itemRefs, draggingIndex, offsets } = useDragData({
    dataList: services,
    onDragEnd,
  })
  return (
    <Box id={'templateServices'} ref={containerRef}>
      {services.map((service, i) => (
        <DraggableItemWrapper
          key={service.id}
          ref={(el) => (itemRefs.current[i] = el as HTMLDivElement | null)}
          draggingIndex={draggingIndex}
          index={i}
          offsets={offsets}
          itemHeight="fit"
        >
          <DraggableServiceCard
            serviceFrequencies={serviceFrequencies}
            service={service}
          />
        </DraggableItemWrapper>
      ))}
    </Box>
  )
}
